var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementSettingModalBase } from './element-setting-modal-base';
import { Size } from '../../diagram/utils/common/size';
var ResizableElementSettingModal = /** @class */ (function (_super) {
    __extends(ResizableElementSettingModal, _super);
    function ResizableElementSettingModal(injector, modelDivId) {
        return _super.call(this, injector, modelDivId) || this;
    }
    ResizableElementSettingModal.prototype.init = function (editedComponent) {
        _super.prototype.init.call(this, editedComponent);
        this.loadSizeInfo(editedComponent.model.data);
    };
    /**
     * load size info
     * @param component : current edited component
     */
    ResizableElementSettingModal.prototype.loadSizeInfo = function (componentData) {
        if (componentData.size && componentData.size.indexOf(' ') > 0) {
            var sizeInfo = componentData.size.split(' ');
            this.width = sizeInfo[0], this.height = sizeInfo[1];
        }
    };
    /**
     * save size info
     */
    ResizableElementSettingModal.prototype.saveSizeInfo = function () {
        this.saveComponentProperty('size', new Size(this.width, this.height).toString());
    };
    return ResizableElementSettingModal;
}(ElementSettingModalBase));
export { ResizableElementSettingModal };
